// extracted by mini-css-extract-plugin
export var generic = "shared-module--generic--zBNB7";
export var attorneyFinancialSectionCorrection = "shared-module--attorneyFinancialSectionCorrection--12yxM";
export var genericContent = "shared-module--genericContent--2wgbA";
export var sharedStyling = "shared-module--sharedStyling--1kj65";
export var sharedContentWrapper = "shared-module--sharedContentWrapper--3THon";
export var listWrapper = "shared-module--listWrapper--QnO-5";